import AgentServices from '@/pages/AgentServices'

export default {
    path: '/agentservices',
    component: AgentServices,
    children: [
        {
            path: '',
            name: 'AgentServices',
            component: AgentServices,
        },
        {
            path: ':ref',
            name: 'RefAgentServices',
            component: AgentServices,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/agentservices.js